<template>

    <m-edit1/>

    <m-section-204 v-bind='{...{"image":"https:\/\/api.kaluxhome.ir\/storage\/contents\/blobe-1765792265.png","sectionContainerMode":"container"},...{}}' :style='""' class="container-fluid" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="mb-4" >
                <template #default>   <m-content-slider-2 v-bind='{...{"contentType":"page","contentCategory":["header-slider"],"contentCard":"mContentCard910","autoPlay":true,"autoPlayDuration":3000,"slicer":12},...{}}' :style='""' class="col-12 p-0 header-slider " ></m-content-slider-2></template>
                </m-div><m-products-3 v-bind='{...{"perPage":12,"productCardName":"mProductCard207_price","cardCLass":"my-1","cardWrapperCLass":"col-lg-4 archive-parent-item mb-3","showCategoriesSlider":false,"singlePrice":false,"offerType":"number","offerStatus":true,"productBrandProp":false,"productShowBreadcrumb":true,"productSearchProp":true,"productQuantityProp":true,"productFeatureProp":false,"productFeaturePanelOpenCloseProp":false,"productCategoryProp":false,"productStoresProp":false,"productSortProp":true,"relatedCurrentCategory":true,"relatedCategoriesProp":true,"productPriceFilterProp":false,"showKeywords":false,"smCardName":"mProductCard207_price","skeleton":"mProductArchiveSkeleton1","dashboardProduct":false,"publishStatusFilter":false,"image":null,"alt":"","cardLink":false,"infinityLoading":true,"chooseCategoriesFromTop":true,"cardLinkTarget":"_self","productStoresDirectFilter":null,"productCategoriesIdsDirectFilter":null,"orderFilterProp":["brand","feature","category","search","quantity","store","price"],"archiveFilterProp":false},...{}}' :style='""' class="my-4 product-archive-3" ></m-products-3></template>
                </m-section-204>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSection204 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section204'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mContentSlider2 from '@moeinmdn/miw-alpha-components/src/package/Content/Slider/ContentSlider2'; import mProducts3 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products3/Products3';

export default {
    name: 'HomeView',
    components: {mEdit1, mSection204,mDiv,mContentSlider2,mProducts3 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
